"use client";

import { useCallback, useRef } from "react";

/**
 * Wrap an async action so a call made while the previous one is still pending is ignored. The guard
 * is a ref set BEFORE the first await, so it holds for calls in the same tick (a held Enter key),
 * where React state (`loading` flags) has not re-rendered yet. Used for the composer send: with a
 * required prechat the send awaits the prechat submit first, and every extra Enter in that window
 * sent the prechat and the message again.
 */
export function useSingleFlight(fn: () => Promise<void>): () => Promise<void> {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  const pending = useRef(false);
  return useCallback(async () => {
    if (pending.current) return;
    pending.current = true;
    try {
      await fnRef.current();
    } finally {
      pending.current = false;
    }
  }, []);
}
